/*
 * 5-М1 «Мой день». Геометрия и типографика из макета «Мастер - П0»:
 * карточка записи radius 14, промежуток пунктиром, завершённый визит opacity .7,
 * кнопка «Клиент пришёл» 44 px, кнопка «Записать» 48 px во всю ширину.
 *
 * Ни одного цвета в файле — только var() из токенов кабинета и master-tokens.css.
 * Тёмная тема поэтому работает сама: мастер смотрит телефон в зале с приглушённым
 * светом, и это не «приятная мелочь», а условие, при котором экран вообще читается.
 */

.gap {
  margin: var(--space-4);
}

.step {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  font-size: var(--font-size-base);
  cursor: pointer;
}

/* Видимый размер стрелки — 40 px из макета, область нажатия дотягивается до 48:
   растёт попадание, а не рисунок (то же правило, что в библиотеке элементов). */
@media (pointer: coarse) {
  .step {
    position: relative;
  }

  .step::after {
    content: "";
    position: absolute;
    inset: -4px;
  }
}

.step:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.shiftLine {
  flex: none;
  margin: 0;
  padding: 0 var(--space-4) var(--space-2);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 var(--space-4) var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeletonCard {
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ─────────── карточка записи ─────────── */

.card {
  flex: none;
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  overflow: hidden;
}

/* Ближайшая запись обведена акцентом. Это не единственный её признак: рядом стоит
   слово «Следующий» — цвет в одиночку смысла не несёт. */
.cardNext {
  border: 1.5px solid var(--accent);
}

.cardPast {
  opacity: 0.7;
}

.cardOpen {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.cardOpen:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: calc(var(--focus-ring-offset) * -1);
}

.cardTop {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.time {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
  flex: none;
}

.timePast {
  color: var(--text-secondary);
}

.nextChip {
  flex: none;
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  background: var(--master-accent-bg);
  border-radius: var(--radius-pill);
  padding: 1px 8px;
}

.statusChip {
  margin-left: auto;
  flex: none;
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-pill);
  padding: 2px 8px;
  color: var(--status-completed-fg);
  background: var(--status-completed-bg);
}

.statusChip[data-status="pending"] {
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
}

.statusChip[data-status="in_progress"] {
  color: var(--status-in-progress-fg);
  background: var(--status-in-progress-bg);
}

.statusChip[data-status="no_show"] {
  color: var(--status-no-show-fg);
  background: var(--status-no-show-bg);
}

.statusChip[data-status="cancelled"] {
  color: var(--status-cancelled-fg);
  background: var(--status-cancelled-bg);
  text-decoration: line-through;
}

.client {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.firstVisit {
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  margin-left: 6px;
}

.service {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.35;
}

.note {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--master-note-fg);
}

.cardActions {
  display: flex;
  gap: var(--space-2);
  padding: 0 14px 12px;
}

.arriveButton {
  flex: 1;
}

/* Звонок — ссылка tel:, а не кнопка: на телефоне её открывает система, и это
   единственный способ позвонить одним касанием, не выходя из приложения. */
.callButton {
  width: 44px;
  height: 44px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-lg);
}

.callButton:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

/* ─────────── промежутки и занятость ─────────── */

.gapRow,
.busyRow {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 10px 14px;
  border-radius: 14px;
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  min-height: var(--touch-min-target);
}

.gapRow {
  border: 1px dashed var(--border);
}

.busyRow {
  border: 1px dotted var(--border-strong);
}

.gapTime {
  font-variant-numeric: tabular-nums;
  flex: none;
}

.gapText {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gapAction {
  margin-left: auto;
  flex: none;
  border: 0;
  background: transparent;
  color: var(--accent);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  /* Область нажатия дотягивается до 44 px по высоте строки, а не рисуется кнопкой:
     ссылка внутри строки не должна выглядеть второй кнопкой рядом с «Записать». */
  padding: 12px 0;
}

.gapAction:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

/* ─────────── итог смены ─────────── */

.total {
  flex: none;
  margin-top: var(--space-1);
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.totalLabel {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.totalValue {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.actionProblem {
  margin: 0;
  padding: 10px 14px;
  border-radius: var(--radius-lg);
  background: var(--status-no-show-bg);
  color: var(--status-no-show-fg);
  font-size: var(--font-size-md);
  line-height: 1.4;
}

/* ─────────── подвал с главным действием ─────────── */

.footer {
  flex: none;
  padding: var(--space-2) var(--space-4) 6px;
}

/* «Перерыв» слева и уже, «Записать» справа на остаток ширины: главное действие дня
   остаётся главным, а перерыв — рядом, в той же зоне большого пальца. */
.footerRow {
  display: flex;
  gap: var(--space-2);
}

.breakButton {
  flex: none;
  height: var(--touch-min-target);
  font-size: var(--font-size-base);
  border-radius: 12px;
}

.bookButton {
  flex: 1;
  height: var(--touch-min-target);
  font-size: var(--font-size-base);
  border-radius: 12px;
}
